import React from 'react';
import { useHistory } from 'react-router';

import { getResetPasswordDetails } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';
import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { Grid, Stack, Typography } from '@mui/material';

import ResetPasswordForm from '@components/forms/resetPassword';

import useResetPassword from '@pages/Auth/ForgotPasswordPage/containers/ResetPassword/hooks';

import ArrowIcon from 'jsx:@assets/svgs/arrowLeft.svg';

import { BackButton } from './styles';

function ResetPasswordPage() {
	const { initialValues, onSubmit } = useResetPassword();

	const history = useHistory();
	const generateRoutePath = useGenerateRoutePath();

	const resetPasswordDetails = useAppSelector(getResetPasswordDetails);

	if (!resetPasswordDetails?.code_type || !resetPasswordDetails?.sentTime) {
		history.replace(generateRoutePath(RoutePaths.AUTH.FORGOT_PASSWORD_METHOD));

		return null;
	}

	return (
		<Grid container>
			<BackButton onClick={() => history.push(generateRoutePath(RoutePaths.AUTH.FORGOT_PASSWORD_METHOD))}>
				<Stack direction={'row'} alignItems={'center'} justifyContent={'center'} gap={1}>
					<ArrowIcon />

					<Typography variant="body2">
						<b>Back to method</b>
					</Typography>
				</Stack>
			</BackButton>

			<Typography variant="body1" mb={2}>
				<b>A verification code has been sent to your {resetPasswordDetails.code_type}. Enter it to reset password:</b>
			</Typography>

			<ResetPasswordForm initialValues={initialValues} onSubmit={onSubmit} sentTime={resetPasswordDetails.sentTime} />
		</Grid>
	);
}

export default ResetPasswordPage;
